import { createFileRoute } from "@tanstack/react-router";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { projectLoader } from "src/lib/ScopedLoaders";
import ConnectorsPage from "src/routes/_authed/portal/-components/ConnectorsPage";
import { getConnectorsPageData } from "src/server/functions/Portal";

export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/connectors")({
  loader: projectLoader((projectId) => getConnectorsPageData({ data: projectId })),
  component: ConnectorsRoute,
});

function ConnectorsRoute() {
  return (
    <DeferredLoaderData result={Route.useLoaderData()}>
      {(data) => (
        <ConnectorsPage
          initialProjectId={data?.projectId}
          initialConnectors={data?.initialConnectors}
          initialDeliveries={data?.initialDeliveries}
          initialInspector={data?.initialInspector}
        />
      )}
    </DeferredLoaderData>
  );
}
